// @ts-strict-ignore
import React, { useEffect, useState } from 'react';
import TypeSelect from 'react-select';
import {
  Box,
  Label,
  Select,
  Text,
} from '@usealloy/component-library';

import { DURATION_OPTIONS, defaultApproverDuration } from './constants';

interface ApproverDurationInputsProps {
  setCustomInputs(customInput: any): void;
  approverOptions: Array<{
    name: string;
    value: string;
  }>;
}

const ApproverDurationInputs: React.FC<ApproverDurationInputsProps> = ({
  setCustomInputs,
  approverOptions,
}) => {
  const [approver, setApprover] = useState(defaultApproverDuration.approver);
  const [duration, setDuration] = useState(defaultApproverDuration.duration);

  useEffect(() => {
    setCustomInputs({ approver, duration });
  }, [approver, duration]);

  const ModalPortal = document.getElementById('alloy-overlay-root');

  return (
    <Box
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      gap={4}
      style={{ width: '100%' }}
    >
      <Box direction="column" alignItems="flex-start" style={{ width: '50%' }}>
        <Label>Approver</Label>
        <TypeSelect
          options={approverOptions}
          placeholder="Type or select an approver"
          onChange={option => { setApprover(option.value); }}
          menuPlacement="auto"
          menuPortalTarget={ModalPortal}
          styles={{
            container: () => ({ width: '100%', height: '40px' }),
            menuPortal: base => ({ ...base, zIndex: 'var(--cl-zindex-popover)' }),
          }}
        />
      </Box>
      <Box direction="column" alignItems="flex-start" style={{ width: 130 }}>
        <Label>Time</Label>
        <Box direction="row" alignItems="center" gap={4}>
          <Select
            options={DURATION_OPTIONS}
            onChange={event => { setDuration(event.target.value); }}
          />
          <Text>day(s)</Text>
        </Box>
      </Box>
    </Box>
  );
};

export default ApproverDurationInputs;
